import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";

const GoogleGate = ({ children }) => {
  const { hash } = useLocation();
  return hash?.includes("session_id=") ? <AuthCallback /> : children;
};
import { Toaster } from "./components/ui/sonner";
import { BrandProvider } from "./lib/brand";
import Shell from "./components/layout/Shell";
import CommandCenter from "./pages/CommandCenter";
import Disputes from "./pages/Disputes";
import DisputeDetail from "./pages/DisputeDetail";
import RiskLab from "./pages/RiskLab";
import EvidenceVault from "./pages/EvidenceVault";
import ConsentCapture from "./pages/ConsentCapture";
import Banks from "./pages/Banks";
import Settings from "./pages/Settings";
import MariPage from "./pages/MariPage";
import Ingestion from "./pages/Ingestion";
import AuditLog from "./pages/AuditLog";
import Savings from "./pages/Savings";
import Intercepts from "./pages/Intercepts";
import MerchantPortal from "./pages/MerchantPortal";
import Landing from "./pages/Landing";
import Playbook, { PublicPlaybook } from "./pages/Playbook";
import Login, { AuthCallback } from "./pages/Login";
import { AcceptInvite, ResetPassword } from "./pages/AcceptInvite";
import Team from "./pages/Team";
import IntegrationHub from "./pages/IntegrationHub";
import UserManual from "./pages/UserManual";
import WhopConnect from "./pages/WhopConnect";
import Connect from "./pages/Connect";
import SetupShared from "./pages/SetupShared";
import Terms from "./pages/Terms";
import Verifications from "./pages/Verifications";
import AdminMonitor from "./pages/AdminMonitor";
import VerifyAccount from "./pages/VerifyAccount";
import WhopApp from "./pages/WhopApp";
import Partner from "./pages/Partner";
import Compliance from "./pages/Compliance";
import Security from "./pages/Security";
import SalesShield from "./pages/SalesShield";
import Partnership from "./pages/Partnership";
import Enterprise from "./pages/Enterprise";
import PartnerDetail from "./pages/PartnerDetail";
import PitchProof from "./pages/PitchProof";
import PrivacyRequest from "./pages/PrivacyRequest";
import EmbedConsent from "./pages/EmbedConsent";
import { AuthProvider, RequireAdmin, RequireAuth, RequireOwner } from "./lib/auth";
import { OnboardingProvider } from "./lib/onboarding";
import { ThemeProvider } from "./lib/theme";

const LegacyRedirect = () => {
  const { pathname } = useLocation();
  return <Navigate to={pathname.startsWith("/app") ? "/app" : `/app${pathname}`} replace />;
};

function App() {
  return (
    <BrandProvider>
      <BrowserRouter>
        <AuthProvider>
        <ThemeProvider>
        <GoogleGate>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/invite/:token" element={<AcceptInvite />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/playbook" element={<PublicPlaybook />} />
          <Route path="/embed/consent" element={<EmbedConsent />} />
          <Route path="/verify" element={<VerifyAccount />} />
          <Route path="/setup/:token" element={<SetupShared />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy/request" element={<PrivacyRequest />} />
          <Route path="/dashboard/:companyId" element={<WhopApp />} />
          <Route path="app" element={<RequireAuth><OnboardingProvider><Shell /></OnboardingProvider></RequireAuth>}>
            <Route index element={<CommandCenter />} />
            <Route path="disputes" element={<Disputes />} />
            <Route path="disputes/:id" element={<DisputeDetail />} />
            <Route path="risk" element={<RiskLab />} />
            <Route path="evidence" element={<EvidenceVault />} />
            <Route path="consent" element={<ConsentCapture />} />
            <Route path="banks" element={<Banks />} />
            <Route path="settings" element={<Settings />} />
            <Route path="mari" element={<MariPage />} />
            <Route path="ingestion" element={<Ingestion />} />
            <Route path="audit" element={<AuditLog />} />
            <Route path="roi" element={<Savings />} />
            <Route path="intercepts" element={<Intercepts />} />
            <Route path="merchant" element={<MerchantPortal />} />
            <Route path="playbook" element={<Playbook />} />
            <Route path="integrations" element={<IntegrationHub />} />
            <Route path="manual" element={<UserManual />} />
            <Route path="whop" element={<WhopConnect />} />
            <Route path="connect" element={<Connect />} />
            <Route path="verifications" element={<Verifications />} />
            <Route path="monitor" element={<RequireAdmin><AdminMonitor /></RequireAdmin>} />
            <Route path="partner" element={<RequireAdmin><Partner /></RequireAdmin>} />
            <Route path="compliance" element={<Compliance />} />
            <Route path="security" element={<Security />} />
            <Route path="sales" element={<SalesShield />} />
            <Route path="partnership" element={<Partnership />} />
            <Route path="enterprise" element={<RequireAdmin><Enterprise /></RequireAdmin>} />
            <Route path="enterprise/proof" element={<RequireAdmin><PitchProof /></RequireAdmin>} />
            <Route path="enterprise/:id" element={<RequireAdmin><PartnerDetail /></RequireAdmin>} />
            <Route path="team" element={<RequireOwner><Team /></RequireOwner>} />
            <Route path="*" element={<Navigate to="/app" replace />} />
          </Route>
          <Route path="*" element={<LegacyRedirect />} />
        </Routes>
        </GoogleGate>
        </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </BrandProvider>
  );
}

export default App;
